import { ValueFormat, ElementType } from '@/typings/designStudio/sourceElementTypes';
import { getElementType } from '@/utils/elementTypeUtils';
import * as mapUtils from './mapUtils';

export const setAllTargetsFromSource = (canvas, source) => {
    if (!canvas || !source) return;
    const targets = canvas.getTargetElements(source.uuid);
    targets.forEach((target) => {
        const { targetElement, valueFormat } = target;
        if (!targetElement || !valueFormat) return;
        setTargetFromSource(source, targetElement, valueFormat);
    });
};

export const setTargetFromSource = (source, target, valueFormat) => {
    if (!source || !target || !valueFormat) return;

    let valueToSet = '';
    const sourceType = getElementType(source);
    //For now, only maps are supported as source elements
    if (sourceType === ElementType.Map) {
        const config = typeof source.mapConfig == 'string' ? JSON.parse(source.mapConfig) : source.mapConfig;
        const { longitude, latitude } = config;
        if (valueFormat === ValueFormat.MapCoordinatesDMS) {
            valueToSet = mapUtils.getMapCoordinates(latitude, longitude).dms;
        } else {
            valueToSet = mapUtils.getMapCoordinates(latitude, longitude).dd;
        }
    }

    const targetType = getElementType(target);
    //For now, only text elements are supported as target elements
    if (targetType === ElementType.Text) {
        target.setText(valueToSet);
    }
};

export const populateElementsLinks = (elementsLinks, canvas, TextService = null) => {
    if (!elementsLinks || !canvas) return;

    for (const link of elementsLinks) {
        const targetElement = canvas.getObjects().find((obj) => obj.uuid === link.targetId);
        const sourceElement = canvas.getObjects().find((obj) => obj.uuid === link.sourceId);
        if (!targetElement || !sourceElement) continue;

        if (link.valueFormat === ValueFormat.TextAsMask) {
            targetElement.hasTextMask = true;
            if (TextService) TextService.addObjectWithTextMask(sourceElement.uuid, targetElement);
            continue;
        }

        if (link.valueFormat === ValueFormat.TextAsCutout) {
            targetElement.hasTextMask = true;
            if (TextService) TextService.addObjectWithTextCutout(sourceElement.uuid, targetElement);
            continue;
        }

        canvas.addLinkElements(link.sourceId, targetElement, link.sourceType, link.valueFormat);
        targetElement.sourceElement = {
            sourceId: link.sourceId,
            sourceType: link.sourceType,
            valueFormat: link.valueFormat
        };
        setTargetFromSource(sourceElement, targetElement, link.valueFormat);
    }
};
